import extendedRoutes from './extendedRoutes';
import getToggleUtil from '../../../featureToggle/getToggleUtil';
import extendedRoutesNuttall from '../../../customized/alan-nuttall-flexeserve-eu/util/route-dom/extendedRoutes/extendedRoutes';

export default getToggleUtil(extendedRoutes, {
  StyledComponentsVariants: {
    'alan-nuttall-flexeserve-eu': extendedRoutesNuttall,
  },
});
